module.exports = __webpack_public_path__ + "img/4.7f844245.png";